export default __webpack_public_path__ + "static/media/stedelijk.f2ee5610.png";